<mat-sidenav-container autosize="true" hasBackdrop="false">
  <mat-sidenav mode="side" opened disableClose="true" class="mappe-navigasjon">
    @if (lasterRot()) {
      <span class="laster-rot">
        <mat-progress-spinner mode="indeterminate" diameter="20"/>
        {{ 'Laster mapper...'|translate }}
      </span>
    }
    <mat-tree [dataSource]="dataSource" [levelAccessor]="nivaa()" [trackBy]="trackBy()" [expansionKey]="nodenoekkel()">
      <mat-tree-node *matTreeNodeDef="let mappe"
                     matTreeNodeToggle
                     matTreeNodePadding
                     matTreeNodePaddingIndent="20"
                     (expandedChange)="ekspandertEndret(mappe, $event)"
                     class="mappe"
                     [class.aktiv]="aktivMappe() === mappe"
                     [class.gruppe]="mappe.gruppe != null"
                     #trenode>
        <button mat-icon-button [attr.aria-label]="'Toggle ' + mappe.node.navn" matTreeNodeToggle class="åpne-lukke mat-large-icon-button">
          @if (mappe.laster()) {
            <mat-progress-spinner mode="indeterminate" diameter="20"/>
          } @else {
            <mat-icon>{{ mappe.ekspandert() ? 'expand_more' : 'chevron_right' }}</mat-icon>
          }
        </button>
        <!-- .stop for at ikke noden skal åpnes av både mappeValgt() og ekspander() (via expandedChange) -->
        <div (click.stopp)="togleITreOgVisInnhold(mappe)" class="mappe" data-testid="mappe-i-tre">
          <span class="ikon">
            @if (mappe.gruppe) {
              <!-- for mappe som representerer gruppe vises vi gruppelogo-->
              <gruppe-logo [gruppe]="mappe.gruppe"/>
            } @else {
              <mat-icon>{{ mappe.ekspandert() ? 'folder_open' : 'folder' }}</mat-icon>
            }
          </span>
          <span class="navn" data-testid="mappe-navn">{{ mappe.node.navn }}</span>
        </div>
      </mat-tree-node>
    </mat-tree>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="valgt-mappe-innhold" data-testid="valgt-mappe">
      @if (aktivMappe() != null) {
        <div class="navigasjon">
          <h2 class="sti" [nedtrekksmenyTriggerFor]="stiMeny" [nedtrekksmenyDeaktivert]="aktivMappe()!.foreldre().length == 0"
              [nedtrekksmenyPosisjon]="[{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 2}]" data-testid="mappe-sti">
            @if (aktivMappe()!.nivaa > 0) {
              <button mat-icon-button class="tilbake" (click.stopp)="gaaTilForelderMappe()">
                <mat-icon>chevron_left</mat-icon>
              </button>
            }
            <!--
             alternativ med utlisting av hele stien:
             @for (element of aktivMappe()!.foreldre(); track element.node.id; ) {
               <span (click)="mappeValgt(element)" class="element">{{ element.node.navn }}</span>
               <mat-icon>chevron_right</mat-icon>
             }
             <span class="aktiv">
              {{ aktivMappe()!.node.navn }}
             </span>-->
            {{ aktivMappe()!.node.navn }}
          </h2>
          <nedtrekksmeny #stiMeny>
            <div class="forelder-sti" data-testid="foreldre">
              @for (element of aktivMappe()!.foreldre().reverse(); track element.node.id; ) {
                <div class="stielement">
                  <mat-icon>folder</mat-icon>
                  <span (click)="togleITreOgVisInnhold(element)" class="element" data-testid="mappe-navn">{{ element.node.navn }}</span>
                </div>
              }
            </div>
          </nedtrekksmeny>

          <div class="handlinger" data-testid="valgt-mappe-handlinger">
            @if (aktivMappe()!.nivaa > 0) {
              <button mat-icon-button
                      [matMenuTriggerFor]="aktivMappeMeny.matMeny()!"
                      (click)="$event.stopPropagation()"
                      blinkElement
                      #mappeMenyBlink="blink"
                      class="mat-medium-icon-button meny"
                      data-testid="valgt-mappe-meny-knapp">
                <mat-icon class="material-symbols-fet">more_vert</mat-icon>
              </button>
              <arkivmappe-meny [mappe]="aktivMappe()!.node" #aktivMappeMeny/>
            }
            <mat-button-toggle-group [formControl]="visningsmodusKontroll" hideSingleSelectionIndicator="true" aria-label="Visningsmodus">
              <mat-button-toggle value="liste" data-testid="listevisning">
                <mat-icon>list</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="kort" data-testid="kortvisning">
                <mat-icon>grid_on</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>

        <p class="beskrivelse"><html-formatert [innhold]="aktivMappe()!.node.beskrivelse"/></p>

        @if (visningsmodusKontroll.value == 'liste') {
          <ng-container *ngTemplateOutlet="listevisningFragment"/>
        } @else {
          <ng-container *ngTemplateOutlet="kortvisningFragment"/>
        }

        @if (aktivMappe()!.laster()) {
          <!--
          antar at det holder med spinner i mat-tree
          <mat-progress-bar mode="indeterminate"/>
          -->
        } @else if (aktivMappe()!.barn().length == 0) {
          <tips>
            {{'Du kan legge til filer ved å'|translate}}
            <ul>
              <li>{{'Dra-og-slippe filer i dette nettleservinduet'|translate}}</li>
              <li>
                {{"Velge 'Nytt dokument' fra"|translate}} <a (click)="mappeMenyBlink()?.blink()">{{'menyen til høyre for mappe-navnet'|translate}}</a>
              </li>
              <li>
                {{"Importer fra en zip-fil ved å velge 'Importer fra zip-fil' fra"|translate}} <a (click)="mappeMenyBlink()?.blink()">{{"menyen til høyre for mappe-navnet"|translate}}</a>
              </li>
            </ul>
          </tips>
        }

        @if (kanOppretteNodeIAktivMappe() && !aktivMappe()!.laster()) {
          <fab-meny toggleKlasseVedSticky>
            <button mat-mini-fab (click)="nyMappe()" color="secondary" [matTooltip]="'Ny mappe'|translate" [attr.aria-label]="'Ny mappe'|translate">
              <mat-icon>create_new_folder</mat-icon>
            </button>
            <button mat-mini-fab (click)="nyttDokument()" color="secondary" [matTooltip]="'Nytt dokument'|translate" [attr.aria-label]="'Nytt dokument'|translate">
              <mat-icon>note_add</mat-icon>
            </button>
          </fab-meny>
        }

      } @else {
        <div class="landingsgrafikk">
          <tips>
            <p>{{'Hver gruppe i en organisasjon har sitt eget private datarom. Alle biblioteksdokumenter kan sendes til signering, akkurat som saksdokumenter.'|translate}}</p>
            <p>{{'Velg organisasjon for å se gruppene i organisasjonen!'|translate}}</p>
          </tips>
          <svg width="194" height="297" viewBox="0 0 194 297" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M178.128 185.086L178.153 185.116L178.183 185.141C179.45 186.227 180.091 187.67 180.091 189.521V280.03C180.091 282.095 179.438 283.748 178.155 285.031L178.141 285.045L178.128 285.06C177.042 286.327 175.6 286.968 173.748 286.968H54.658C52.8141 286.968 51.1525 286.33 49.657 285.031C48.3576 283.535 47.7201 281.874 47.7201 280.03V179.994C47.7201 178.142 48.3606 176.7 49.6277 175.614L49.6425 175.601L49.6562 175.588C50.9399 174.304 52.5923 173.651 54.658 173.651H88.0032C89.8556 173.651 91.4137 174.294 92.7073 175.588L99.555 182.435C100.08 182.96 100.827 183.179 101.699 183.179H173.748C175.6 183.179 177.042 183.819 178.128 185.086ZM51.4732 202.026V202.727L52.1382 202.505C52.6612 202.331 53.3944 202.233 54.3603 202.233H173.45C174.416 202.233 175.15 202.331 175.672 202.505L176.337 202.727V202.026V189.521C176.337 188.749 176.144 188.076 175.668 187.601C175.193 187.125 174.521 186.932 173.748 186.932H101.699C99.8462 186.932 98.2881 186.289 96.9945 184.996L90.1468 178.148C89.6217 177.623 88.875 177.405 88.0032 177.405H54.658C53.7133 177.405 52.9117 177.586 52.3382 178.032C51.7404 178.497 51.4732 179.183 51.4732 179.994V202.026ZM176.337 280.03V208.873C176.337 208.001 176.119 207.255 175.594 206.73C175.069 206.205 174.322 205.986 173.45 205.986H54.3603C53.4884 205.986 52.7418 206.205 52.2166 206.73C51.6915 207.255 51.4732 208.001 51.4732 208.873V280.03C51.4732 280.806 51.8639 281.523 52.5144 282.173C53.1649 282.824 53.8813 283.214 54.658 283.214H173.748C174.559 283.214 175.245 282.947 175.71 282.35C176.156 281.776 176.337 280.974 176.337 280.03Z" fill="#CBCBCF" stroke="white" stroke-width="2.5"/>
          <path d="M39.0231 62.4506L65.7012 73.4471M65.7012 73.4471L50.2889 79.8623C49.3805 80.2404 48.3592 80.2421 47.4495 79.8672C46.5399 79.4922 45.8164 78.7713 45.4383 77.8629L39.0231 62.4506L8.19841 75.2809C7.29005 75.659 6.56909 76.3825 6.19414 77.2921C5.81918 78.2018 5.82094 79.2232 6.19904 80.1315L31.147 140.068C31.5251 140.977 32.2486 141.698 33.1582 142.073C34.0679 142.448 35.0892 142.446 35.9976 142.068L82.2347 122.822C83.143 122.444 83.864 121.721 84.2389 120.811C84.6139 119.901 84.6121 118.88 84.234 117.972L65.7012 73.4471Z" stroke="#CBCBCF" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          <g clip-path="url(#clip0_95_3302)">
            <path d="M61.217 109.038L56.9733 110.787L46.1278 103.427L44.3157 112.229L50.381 109.728L51.7164 112.966L38.9798 118.218L42.3669 101.194L30.5813 93.2577L34.825 91.5079L43.6279 97.3505L45.541 87.0893L49.7895 85.3375L46.8994 99.5527L61.217 109.038Z" fill="#01723A" fill-opacity="0.6"/>
          </g>
          <path d="M173.507 122.4L183.454 140.178M183.454 140.178L172.112 136.975C171.444 136.786 170.878 136.339 170.539 135.733C170.199 135.127 170.115 134.411 170.304 133.742L173.507 122.4L150.823 115.994C150.155 115.805 149.439 115.889 148.832 116.228C148.226 116.568 147.78 117.134 147.591 117.802L135.133 161.91C134.944 162.578 135.029 163.295 135.368 163.901C135.707 164.507 136.273 164.953 136.942 165.142L170.968 174.752C171.636 174.941 172.352 174.857 172.959 174.518C173.565 174.178 174.011 173.612 174.2 172.944L183.454 140.178Z" stroke="#CBCBCF" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          <g clip-path="url(#clip1_95_3302)">
            <path d="M161.687 137.689L164.186 138.448L162.499 152.985L168.546 142.677L165.548 141.766L166.356 139.108L172.843 141.081L162.122 159.581L159.456 158.77L160.945 144.896L154.124 157.149L151.458 156.338L152.857 135.004L155.691 135.866L154.501 150.553" fill="#1A5ABC" fill-opacity="0.6"/>
          </g>
          <path d="M158.48 13.0618L174.41 41.6033M174.41 41.6033L156.217 36.4442C155.145 36.1402 154.237 35.4226 153.694 34.4494C153.151 33.4762 153.017 32.3271 153.321 31.2549L158.48 13.0618L122.094 2.74363C121.021 2.43957 119.872 2.57391 118.899 3.1171C117.926 3.66029 117.208 4.56783 116.904 5.64007L96.8413 76.3909C96.5372 77.4632 96.6715 78.6123 97.2147 79.5855C97.7579 80.5587 98.6654 81.2762 99.7377 81.5803L154.317 97.0575C155.389 97.3616 156.538 97.2272 157.511 96.684C158.485 96.1409 159.202 95.2333 159.506 94.1611L174.41 41.6033Z" stroke="#CBCBCF" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          <g clip-path="url(#clip2_95_3302)">
            <path d="M155.316 69.5017C154.59 66.2553 148.34 62.4903 142.466 60.402C142.096 59.6625 141.724 58.8979 141.348 58.0886C137.936 50.7068 138.363 41.5537 138.912 36.8068C139.098 35.8222 139.231 34.9916 139.32 34.3698C139.387 33.8779 139.536 32.8489 138.509 32.548C138.18 32.4515 137.825 32.5012 137.524 32.6853C137.034 32.9932 136.958 33.4568 136.877 33.995C136.773 34.6122 136.65 35.437 136.54 36.3928C135.632 41.1191 133.272 49.9277 127.701 55.8363C127.121 56.4502 126.549 57.0404 125.994 57.5938C118.821 57.5876 112.476 59.4596 110.868 62.0732C110.284 63.0183 110.238 64.0783 110.742 65.061C111.334 66.2057 112.206 66.9473 113.335 67.2782C116.462 68.1947 121.049 65.7562 126.968 60.0263C128.841 60.0815 130.66 60.2645 132.378 60.5896C133.047 60.7175 134.138 60.8837 134.82 60.9728C136.679 61.2201 138.726 61.7007 140.774 62.3769C144.101 68.7703 147.279 72.4456 150.219 73.3071C151.794 73.7688 153.328 73.3834 154.529 72.219C155.265 71.4802 155.554 70.5257 155.317 69.5019L155.316 69.5017ZM114.012 64.9625C113.526 64.82 113.16 64.5 112.879 63.9491C112.765 63.7285 112.769 63.5679 112.913 63.3372C113.743 61.9872 117.865 60.4681 123.346 60.0899C119.254 63.6879 115.822 65.493 114.011 64.9622L114.012 64.9625ZM135.126 58.5831C134.487 58.4983 133.445 58.3378 132.815 58.2213C131.662 58.0026 130.457 57.8457 129.228 57.7409C129.303 57.6603 129.377 57.5806 129.462 57.494C132.192 54.596 134.464 50.8233 136.237 46.2556C136.522 51.1788 137.506 55.4888 139.178 59.1061C139.224 59.2131 139.276 59.3222 139.33 59.4316C137.853 59.0411 136.447 58.7572 135.127 58.5833L135.126 58.5831ZM152.842 70.4802C152.258 71.0505 151.624 71.206 150.841 70.9763C149.007 70.4389 146.696 67.8696 144.251 63.6945C149.286 65.8858 152.649 68.584 152.973 70.0335C153.021 70.244 152.994 70.3375 152.842 70.4811L152.842 70.4802Z" fill="#FA5337" fill-opacity="0.6"/>
          </g>
          <defs>
            <clipPath id="clip0_95_3302">
              <rect width="25.9451" height="33.2195" fill="white" transform="translate(27 90.8904) rotate(-22.4081)"/>
            </clipPath>
            <clipPath id="clip1_95_3302">
              <rect width="23.1181" height="26.3191" fill="white" transform="translate(152.656 132) rotate(16.912)"/>
            </clipPath>
            <clipPath id="clip2_95_3302">
              <rect width="53.069" height="48.4409" fill="white" transform="translate(117.623 23) rotate(16.3343)"/>
            </clipPath>
          </defs>
        </svg>
        </div>
      }
    </div>
  </mat-sidenav-content>

  <mat-sidenav mode="side" position="end" disableClose="true" class="valgt-node-detaljer">
    <button mat-icon-button (click)="skjulDetaljer()" class="lukk-detaljer mat-large-icon-button">
      <mat-icon>right_panel_close</mat-icon>
    </button>
    @if (valgtMappe()) {
      <arkivmappe-detaljer [mappe]="valgtMappe()!.node"/>
    }
    @if (valgtDokument()) {
      <dokument-detaljer [dokumentversjon]="valgtDokument()!.node.dokument" [redigerbar]="kanRedigereAktivMappe()"/>
    }
  </mat-sidenav>
</mat-sidenav-container>

<div (draOgSlippFil)="filerValgtForOpplasting($event)"
     [draOgSlippStoettet]="draOgSlippFilStoettet()"
     [meldingVedAktivert]="draOgSlippIndikatorFragment"
     [meldingVedIkkeStoettet]="draOgSlippIkkeStoettetIndikatorFragment"></div>

<ng-template #draOgSlippIndikatorFragment>
  <dra-og-slipp-fil-aktivert-melding>{{ 'Slipp filene for å laste opp under mappen {navn}'|translate: {navn: aktivMappe()!.node.navn} }}</dra-og-slipp-fil-aktivert-melding>
</ng-template>

<ng-template #draOgSlippIkkeStoettetIndikatorFragment>
  <dra-og-slipp-fil-aktivert-melding ikon="block">
    @if (!aktivMappe()) {
      {{ 'Du må velge en mappe før du kan dra-og-slippe filer til denne'|translate }}
    } @else {
      {{ 'Mappen {navn} støtter ikke opplasting av filer'|translate: {navn: aktivMappe()!.node.navn} }}
    }
  </dra-og-slipp-fil-aktivert-melding>
</ng-template>

<!-- kort-visning av mapper og dokumenter -->
<ng-template #kortvisningFragment>
  <div class="kortvisning">
    @if (aktivMappe()!.mapper().length > 0) {
      <tittel-verdi stil="vertikal--med-linje">
        <tittel>
          {{ 'Mapper'|translate }}
          @if (kanRedigereAktivMappe()) {
            <button mat-icon-button (click)="nyMappe()">
              <mat-icon>add_circle</mat-icon>
            </button>
          }
        </tittel>
        <verdi>
          <div class="kortvisning-mapper">
            @for (mappe of aktivMappe()!.mapper(); track mappe.node.id) {
              <arkivmappe-kortvisning [mappe]="mappe.node" [class.valgt]="valgtNode() == mappe" (click)="visDetaljerFor(mappe)" (dblclick)="ekspanderBarnAvAktivMappe(mappe); $event.stopPropagation()"/>
            }
          </div>
        </verdi>
      </tittel-verdi>
    }
    @if (aktivMappe()!.filer().length > 0 || opplastinger().length > 0) {
      <tittel-verdi stil="vertikal--med-linje">
        <tittel>
          {{ 'Dokumenter'|translate }}
          @if (kanRedigereAktivMappe()) {
            <button mat-icon-button (click)="nyttDokument()">
              <mat-icon>add_circle</mat-icon>
            </button>
          }
        </tittel>
        <verdi>
          <div class="kortvisning-dokumenter">
            @for (fil of aktivMappe()!.filer(); track fil.node.id) {
              <dokument-kortvisning [dokumentversjon]="fil.node.dokument" [class.valgt]="valgtNode() == fil" (click)="visDetaljerFor(fil)"/>
            }
            @for (opplasting of opplastinger(); track opplasting) {
              <dokument-opplasting-kortvisning [opplasting]="opplasting" (vedAvbryt)="opplasting.avbryt()" @fadeInnUt/>
            }
          </div>
        </verdi>
      </tittel-verdi>
    }
    @if (aktivMappe()!.tom() && opplastinger().length == 0) {
      <div class="tom">{{ 'Mappen er tom'|translate }}</div>
    }
  </div>
</ng-template>

<!-- liste-visning av mapper og dokumenter -->
<ng-template #listevisningFragment>
  <table class="listevisning">
    <thead>
    <tr>
      <th class="ikon"><!-- ikon --></th>
      <th>{{'Navn'|translate}}</th>
      <th><!-- versjonsnr --></th>
      <th><!-- ant sider --></th>
      <th><!-- ant annot --></th>
      <th><!-- inlinevisning --></th>
      <th><!-- åpne --></th>
      <th><!-- meny--></th>
    </tr>
    </thead>
    @for (mappe of aktivMappe()!.mapper(); track mappe.node.id) {
      <arkivmappe-listevisning [mappe]="mappe.node" [class.valgt]="valgtNode() == mappe" (click)="visDetaljerFor(mappe)" (dblclick)="ekspanderBarnAvAktivMappe(mappe)"/>
    }
    @for (fil of aktivMappe()!.filer(); track fil.node.id) {
      <dokument-listevisning [dokumentversjon]="fil.node.dokument" [class.valgt]="valgtNode() == fil" (click)="visDetaljerFor(fil)"/>
    }
    @for (opplasting of opplastinger(); track opplasting) {
      <dokument-opplasting-listevisning [opplasting]="opplasting" (vedAvbryt)="opplasting.avbryt()" @fadeInnUt/>
    }
    @if (aktivMappe()!.tom() && opplastinger().length == 0) {
      <tr class="tom">
        <th><!-- ikon --></th>
        <th colspan="7">{{ 'Mappen er tom'|translate }}</th>
      </tr>
    }
  </table>
</ng-template>
